var map = {
	"./gallery-wip-denix-grips_00.jpg": 2853,
	"./gallery-wip-denix-grips_01.jpg": 2854,
	"./gallery-wip-denix-grips_02.jpg": 2855,
	"./gallery_00.jpg": 2856,
	"./gallery_01.jpg": 2857,
	"./gallery_02.jpg": 2858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2852;